import { createAction, props } from '@ngrx/store';
import { DialogData } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';

export const alleVerrechnetStart = createAction('ZEIT::ALLEVERRECHNET_START', props<{ items: DialogData }>());
export const alleVerrechnetSucceeded = createAction('ZEIT::ALLEVERRECHNET_SUCCEEDED', props<{ items: DialogData }>());
export const alleVerrechnetFailed = createAction('ZEIT::ALLEVERRECHNET_FAILED', props<{ error: Error }>());
